
export enum ExpectationOwnerTypeCd {
	DOOR = 'Door',
	SERVICER_CENTER = 'ServicerCenter',
	SHIPMENT = 'Shipment',
	TRAILER = 'Trailer'}

